import React from "react";
import {Heading, List, ListItem, Stack, Text} from "@chakra-ui/react";

export const BlogPost1 = () => {
    return (
        <Stack spacing={3}>
            <Text>As Overland Park residents we are lucky enough to enjoy all four seasons! With all four seasons,
                however, comes unique needs and conditions for our trees and landscaping. Whether you’ve got a green
                thumb or not, there are certain things to know and do that can help you preserve and maintain the trees
                that bring so much beauty to your property.</Text>
            <Heading as="h2" fontSize={'xl'}>Here are some of our top tree care tips:</Heading>
            <List styleType="disc">
                <ListItem>
                    <b>Preservation of Tree Health:</b> By removing dead or dying branches, your tree will be able to fight off
                    disease and infestation more effectively, thus preserving its overall health and vitality.
                </ListItem>
                <ListItem>
                    <b>Enhanced Safety:</b> Untamed or unruly branches can pose a significant safety risk, especially during high
                    winds or storms. Regular tree trimming helps create a safer environment by reducing the likelihood of falling
                    branches that could cause property damage or personal injury.
                </ListItem>
                <ListItem>
                    <b>Improved Aesthetics:</b> Regular tree trimming helps maintain an attractive appearance for your property
                    and landscape. It prevents trees from becoming overgrown and unkempt, thus enhancing the overall visual appeal.
                </ListItem>
                <ListItem>
                    <b>Clearer Views:</b> Overgrown trees can obstruct beautiful views. Regular tree trimming ensures that trees
                    don't block desirable vistas, allowing you to enjoy the scenery and natural beauty surrounding your property.
                </ListItem>
                <ListItem>
                    <b>Increased Property Value:</b> A well-maintained landscape with neatly trimmed trees adds value to your home.
                    It serves as a selling point and leaves a positive impression on potential buyers or visitors, enhancing the
                    overall appeal and desirability of your property.
                </ListItem>
            </List>

            <Text>The more you learn the more you’ll understand how to proceed and care for your trees! When in doubt,
                don’t be afraid to consult one of Overland Park Tree Care’s specialists or arborists.</Text>
        </Stack>
    )
}